module.exports = __webpack_public_path__ + "static/media/new5.04fbdb47.jpg";